<div class="spin-wrap">
  <div class="spin-aura"></div>

  @if (showHeaderSection) {
    <button class="playbook-btn" (click)="showGuide()">
      <span class="relative z-10 tracking-wide">Playbook</span>
    </button>
  }

  @if (showHeaderSection) {
    <div class="spin-intro">
      @if (freeSpinAvailable) {
        <span class="welcome-badge">
          <span class="welcome-dot"></span>
          Welcome bonus — your first spin is free
        </span>
      }
      <h1 class="spin-title">Spin <span class="amp">&amp;</span> Win</h1>
      <p class="spin-subtitle">
        Give the wheel a spin and win instant rewards. Your welcome prize will
        be credited to your account.
      </p>
    </div>
  }

  <div class="relative z-[1] flex flex-col items-center gap-4">
    <div class="wheel-stage">
      <div class="wheel-pointer" [class.wobble]="isSpinning"></div>

      <div class="wheel-ring">
        <div class="wheel-inner">
          <svg
            class="wheel-svg"
            [class.spinning]="isSpinning"
            viewBox="0 0 200 200"
            [style.transform]="'rotate(' + rotation + 'deg)'"
          >
            <g
              *ngFor="let segment of segments; let i = index"
              class="seg-group"
              [class.win]="i === highlightedIndex"
            >
              <path [attr.d]="segmentPath(i)" [attr.fill]="segmentFill(i)" />
              <image
                class="seg-image"
                [attr.href]="segImage(i)"
                [attr.x]="imageX(i)"
                [attr.y]="imageY(i)"
                [attr.width]="19"
                [attr.height]="19"
                [attr.transform]="imageTransform(i)"
                preserveAspectRatio="xMidYMid meet"
              />
              <text
                class="seg-label"
                [attr.x]="textX(i)"
                [attr.y]="textY(i)"
                [attr.transform]="textTransform(i)"
                text-anchor="middle"
              >
                {{ segment.prize }}
              </text>
            </g>
          </svg>
        </div>
      </div>

      <button
        class="wheel-hub"
        [disabled]="isSpinning || !isBalanceSufficient || !isSpinAllowed"
        [attr.aria-disabled]="
          isSpinning || !isBalanceSufficient || !isSpinAllowed ? true : null
        "
        (click)="onCentralHubClick($event)"
      >
        <span class="hub-main">SPIN</span>
        <span class="hub-sub">{{ hubSubText }}</span>
      </button>
    </div>

    @if (!fresspinWindowIsOpen) {
      <p class="status-line status-line--warn">
        <span class="status-line__tag">Eligibility Update:</span> You are not
        currently eligible for a free spin.
        <span class="status-line__link" (click)="RedirectToWallet()"
          >Deposit now</span
        >
        to unlock your daily free spin for the next 5 days!
      </p>
    } @else if (freeSpinAvailable) {
      <p class="status-line status-line--ok">
        Your Free Spin is Ready! Click "Try Your Luck" to spin!
      </p>
    }

    <div class="stat-grid">
      <div class="stat-card">
        <p class="stat-card-label">Free spins</p>
        <p class="stat-card-value stat-card-value--gold">
          {{ freeSpinAvailable ? 1 : 0 }}
        </p>
      </div>
      <div class="stat-card">
        <p class="stat-card-label">Wallet</p>
        <p class="stat-card-value stat-card-value--white">
          ${{ walletBalance ?? 0 | number: "1.2-2" }}
        </p>
      </div>
    </div>

    <div class="pay-banner">
      @if (fresspinWindowIsOpen && !freeSpinAvailable && freeSpinRemainingTime > 0) {
        <div class="pay-banner__row">
          <span class="pay-banner__left">
            <svg
              class="pay-banner__icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span class="pay-banner__text">Next free spin</span>
          </span>
          <span class="pay-banner__timer-value">{{ freeSpinFormattedTime }}</span>
        </div>
      }
      <div class="pay-banner__row">
        <span class="pay-banner__left">
          <svg
            class="pay-banner__icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
          </svg>
          <span class="pay-banner__text">Out of free spins? Pay to spin</span>
        </span>
        <span class="pay-banner__price"
          >${{ spinAmount ? (spinAmount | number: "1.2-2") : "0.00" }}</span
        >
      </div>
    </div>

    <div class="spin-card w-full p-4">
      <div class="amount-controls-row">
        <div class="input-group">
          <button
            class="decrement-btn"
            (click)="decrementSpinAmount()"
            [disabled]="freeSpinAvailable"
          >
            -
          </button>
          <input
            type="text"
            class="amount-input"
            [value]="freeSpinAvailable ? 'Free' : spinAmount"
            readonly
          />
          <button
            class="increment-btn"
            (click)="incrementSpinAmount()"
            [disabled]="freeSpinAvailable"
          >
            +
          </button>
        </div>

        <button
          class="spin-btn-new"
          (click)="freeSpin()"
          [disabled]="
            isSpinning ||
            (!freeSpinAvailable && (!isBalanceSufficient || !isSpinAllowed))
          "
          [attr.aria-disabled]="
            isSpinning ||
            (!freeSpinAvailable && (!isBalanceSufficient || !isSpinAllowed))
              ? true
              : null
          "
        >
          <span class="btn-text">
            @if (freeSpinAvailable) {
              Free Spin
            } @else {
              {{
                isBalanceSufficient ? "Try Your Luck" : "Insufficient Balance"
              }}
            }
          </span>
        </button>
      </div>
    </div>

    <div class="spin-card how-card w-full p-4">
      <p class="how-title">
        <svg
          class="how-title__icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        How It Works
      </p>
      <div class="flex flex-col gap-3">
        <div class="how-step">
          <span class="how-num">1</span>
          <p class="how-text">
            Tap <b class="how-accent">SPIN</b> in the middle of the wheel.
          </p>
        </div>
        <div class="how-step">
          <span class="how-num">2</span>
          <p class="how-text">
            You get <b class="how-accent">1 free spin every day</b> — come back
            tomorrow for more.
          </p>
        </div>
        <div class="how-step">
          <span class="how-num">3</span>
          <p class="how-text">
            Out of free spins? A paid spin costs from your balance, chosen with
            the amount stepper above.
          </p>
        </div>
        <div class="how-step">
          <span class="how-num">4</span>
          <p class="how-text">
            Winnings are credited straight back to your wallet.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="SpinAgainModal"
  class="fixed spinagian inset-0 bg-black/80 flex items-center justify-center"
  (click)="CloseSpinAgainModal()"
>
  <div
    class="bg-[#2A2A2A] rounded-3xl p-6 w-[32rem] modal slide-up"
    (click)="$event.stopPropagation()"
  >
    <div class="flex justify-between items-center mb-4">
      <h2 class="text-xl font-bold">Spin Again</h2>
      <button (click)="CloseSpinAgainModal()" class="text-gray-400">
        <fa-icon [icon]="crossicon"></fa-icon>
      </button>
    </div>
    <hr class="border-gray-500 mb-4" />
    <div class="mb-4 w-full text-center">
      <p class="text-md text-gray-300">
        Spin again for just <span class="text-[#f5cf6b]">$2</span> to win more!
      </p>
    </div>
    <div class="flex justify-center">
      <button type="submit" class="spin-btn" (click)="paidSpin()">
        Spin Now
      </button>
    </div>
  </div>
</div>
